module.exports = __webpack_public_path__ + "static/media/cb-sign-up-poster.64d26a22.png";